/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Status_PendingInputs */

const en_admin_payments_status_pending = /** @type {(inputs: Admin_Payments_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending`)
};

const zh_admin_payments_status_pending = /** @type {(inputs: Admin_Payments_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`待支付`)
};

/**
* | output |
* | --- |
* | "Pending" |
*
* @param {Admin_Payments_Status_PendingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_payments_status_pending = /** @type {((inputs?: Admin_Payments_Status_PendingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Status_PendingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_payments_status_pending(inputs)
	return zh_admin_payments_status_pending(inputs)
});
export { admin_payments_status_pending as "admin.payments.status_pending" }